<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="dialogShow"
    class="items-no-padding password-setting sidebar-dialog">
    <div class="sidebar-content">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div class="top-left">
          <span class="dialog-title">
            {{title}}
          </span>
        </div>
        <feather-icon icon="XIcon" @click.stop="close" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar
        class="scroll-area--customizer pt-4 pb-6"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="content">
<!--
:trade-cycle-list="ICopyList"
-->
          <sub-man-slider-bar
              ref="siderbarinner"
              @current-cycle="acceptCurrentCycle"
          ></sub-man-slider-bar>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>

import subManSliderBar from "@/components/user/details/mamSub/ICopy/subManSliderBar";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: "mobileICopySiderBar",
  components: {
    subManSliderBar,
    VuePerfectScrollbar,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    ICopyList: {
      type: Array,
      default(){
        return [];
      }
    },
  },
  data() {
    return {
      title: this.$t('my_subscription'),

      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
    }
  },
  methods: {
    close(){
      this.$emit('close')
    },
    acceptCurrentCycle(currentCycle){
      this.$emit('current-cycle',currentCycle);
    },
  },
}
</script>

<style lang="scss">
.password-setting {
  .content {
  }
  .vericode-form-item {
    margin-bottom: 5px;
  }
}
</style>
<style lang="scss">
.password-setting {
  .vs-sidebar--items {

  }
  .dititle-title {
    font-weight: 600;
    font-size: 18px;
    color: #5E5873;
  }
  .scroll-area--customizer {
    height: calc(100% - 4rem);
  }
  .top-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .dialog-title {
      margin-right: 20px;
    }
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }

}
</style>
